import { useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import { CloudUpload } from "@material-ui/icons";
import BuildIcon from "@material-ui/icons/Build";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import {
  Container,
  MTable,
  PaginationTable,
  Panel,
  BoxDialog,
  SelectDropDown,
  DeleteAlert,
  Pagination,
} from "../../../../Components";
import { useStyles } from "./Document.styles";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CustomerServicesApi from "../../../../Redux/Actions/CustomerAction";
import DocumentGroupServices from "../../../../Redux/Actions/DocumentGroup/DocumentGroupAction";
import { useApiValidationSnackbar } from "../../../../Components/Snackbar/SnackbarAlert";
import { MTableToolbar } from "@material-table/core";
import { useSnackbar } from "notistack";
import { UnarchiveAlert } from "../../../../Components/Model/UnarchiveAlert";
import { render } from '@testing-library/react';
import moment from "moment";
interface documentProps {
  action: boolean;
}
export const ArchiveDocumentMls = ({ action }: documentProps) => {
  let {
    apiToken,
    currentUser,
    allDocuments,
    allCustomers,
    usersPermission,
    groupUsersPermission,
  } = useSelector((state: any) => ({
    apiToken: state?.UserReducer?.apiToken,
    currentUser: state?.UserReducer?.currentUser,
    allDocuments: state?.CustomerReducer?.allDocuments,
    allCustomers: state?.CustomerReducer?.allCustomers,
    usersPermission: state.CustomerReducer.usersPermission,
    groupUsersPermission: state.CustomerReducer.groupUsersPermission,
  }));
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { notifySuccess, ErrorMessage } = useApiValidationSnackbar();
  const navigate = useNavigate();
  const { upload } = useParams();
  const dispatch: any = useDispatch();
  let [permissionButton, setPermissionButton] = useState<any>(null);
  let [selected, setSelected] = useState<any>(
    currentUser?.customerId == 0 ? [] : currentUser?.customerId
  );
  const [reload, setReload] = useState(false);
  let [open, setOpen] = useState<any>(false);
  let [alertDeleteOpen, setAlertDeleteOpen] = useState<any>(false);
  let [alertunarchiveOpen, setAlertunarchiveOpen] = useState<any>(false);
  let [getDocuments, setGetDocuments] = useState<any>(null);
  const [page, setPage] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [rowsPerPage, setRowsPerPage] = useState(50);

  useEffect(() => {
    try {
      setReload(true)
      let customerId = currentUser?.customerId;
      let isArchive = true
      dispatch(
        CustomerServicesApi?.getAllDocuments(
          selected,
          currentUser?.id,
          apiToken,
          isArchive
        )
      );
      dispatch(DocumentGroupServices?.allDocumentGroups(customerId, apiToken));
      setReload(false)
    } catch (error) {
      let internalError: any = "internalError";
      ErrorMessage(allDocuments, internalError);
    }
  }, []);
  const closeBox = () => setOpen(false);
  const bodydata: any = [
    {
      title: formatMessage({
        id: "document.table.documentName",
        defaultMessage: "Document Name",
      }),
      field: "name",
    },
    {
      title: formatMessage({
        id: "document.table.description",
        defaultMessage: "Description",
      }),
      field: "description",
    },
    // {
    //   title: formatMessage({
    //     id: "document.group.documentUrl",
    //     defaultMessage: "Document URL",
    //   }),
    //   field: "url",
    //   render: (rowData: any) => (
    //     <div
    //       // onClick={() => console.log(rowData, "columnrow")}
    //       className={classes.downloadpdf}
    //     >
    //       {rowData?.url}
    //     </div>
    //   ),
    // },
    {
      title: formatMessage({
        id: "document.table.folder",
        defaultMessage: "Documents Group",
      }),
      field: "documentGroupName",
    },
    {
      title: formatMessage({
        id: "document.table.ArchiveAt",
        defaultMessage: "ArchiveAt",
      }),
      field: "archiveAt",
      render: (data: any) => {
        
        return data?.archiveAt?moment(data?.archiveAt).format('ll'):"-"
      }
    },
  ];

  // if (currentUser?.role !== "User" && action) {
  //   bodydata.splice(2, 0, {
  //     title: formatMessage({
  //       id: "document.group.documentUrl",
  //       defaultMessage: "Document URL",
  //     }),
  //     field: "url",
  //     render: (rowData: any) => (
  //       <div
  //         // onClick={() => console.log(rowData, "columnrow")}
  //         className={classes.downloadpdf}
  //       >
  //         {rowData?.url}
  //       </div>
  //     ),
  //   });
  // }
  const downloadFile = (rowData: any) => {
    dispatch(
      CustomerServicesApi?.downloadFile(
        rowData,
        apiToken,
        notifySuccess,
        ErrorMessage
      )
    );
  };
  const editDocument = (rowData: any) => ({
    tooltip: formatMessage({
      id: "component.mtable.changeTooltip",
      defaultMessage: "edit",
    }),
    icon: "edit",
    disabled: rowData?.permission == 1 ? true : false,
    onClick: () => {
      navigate(`/ms/administrations/archive/upload-document/${rowData?.id}`, {
        state: { rowData },
      });
    },
  });
  const deleteDocument = (rowData: any) => ({
    tooltip: formatMessage({
      id: "component.mtable.deleteTooltip",
      defaultMessage: "delete",
    }),
    icon: "delete",
    disabled: rowData?.permission == 1 ? true : false,
    onClick: () => {
      setAlertDeleteOpen(true);
      setGetDocuments(rowData);
    },
  });
  const downloadDocument = (rowData: any) => ({
    tooltip: formatMessage({
      id: "component.mtable.downloadTooltip",
      defaultMessage: "Downlaod",
    }),
    icon: "download",
    disabled: rowData?.permission == 1 ? true : false,
    onClick: () => {
      downloadFile(rowData)
    },
  });
  const unachiveDocument = (rowData: any) => ({
    tooltip: formatMessage({
      id: "component.mtable.unarchive",
      defaultMessage: "Unarchive",
    }),
    icon: "unarchive",
    disabled: rowData?.permission == 1 ? true : false,
    onClick: () => {
      setAlertunarchiveOpen(true);
      setGetDocuments(rowData);
    },
  });


  const permission = (user: any) => ({
    tooltip: formatMessage({
      id: "group.user.editPermission",
      defaultMessage: "Edit Permission",
    }),
    icon: () => <BuildIcon />,
    hidden: currentUser?.role == "ClientAdmin" ? false : true,
    onClick: () => {
      let customerId = user?.id;
      let DOCUMENT_ADD = `documents/`;
      setOpen(true);
      dispatch(
        CustomerServicesApi?.getUsersPermission(
          DOCUMENT_ADD,
          customerId,
          apiToken,
          enqueueSnackbar
        )
      );
      dispatch(
        CustomerServicesApi?.getUsersGroupPermission(
          DOCUMENT_ADD,
          customerId,
          apiToken
        )
      );
      setPermissionButton(user);
    },
  });
  const onhandleChange = (event: any) => {
    setSelected(event?.target?.value);
    let customerId = event?.target?.value;
    let isArchive = true
    dispatch(
      CustomerServicesApi?.getAllDocuments(
        customerId,
        currentUser?.id,
        apiToken,
        isArchive
      )
    );
  };
  const deletedDocument = () => {
    let DOCUMENT_ADD = `documents/`;
    dispatch(
      CustomerServicesApi?.getUsersPermission(
        DOCUMENT_ADD,
        getDocuments?.id,
        apiToken,
        enqueueSnackbar
      )
    );
    dispatch(
      CustomerServicesApi?.getUsersGroupPermission(
        DOCUMENT_ADD,
        getDocuments?.id,
        apiToken
      )
    );
    setTimeout(() => {
      if (usersPermission?.length > 0 || groupUsersPermission?.length > 0) {
        enqueueSnackbar(formatMessage({ id: "document.group.error.message" }), {
          variant: "error",
        });
        setAlertDeleteOpen(false);
      } else {
        setReload(true);
        dispatch(
          CustomerServicesApi.deleteDocumentFile(
            getDocuments?.id,
            apiToken,
            enqueueSnackbar
          )
        );
        let isArchive = true
        setTimeout(() => {
          dispatch(
            CustomerServicesApi.getAllDocuments(
              selected,
              currentUser?.id,
              apiToken,
              isArchive
            )
          );
          setReload(false);
          setAlertDeleteOpen(false);
        }, 1500);
      }
    }, 1000);
  };

  const unarchiveSubmit = async () => {
    let formData = {
      File: getDocuments?.url,
      Description: getDocuments?.description,
      Name: getDocuments?.name,
      DocumentGroupId: Number(getDocuments?.documentGroupId),
      isArchive: false
    };
    let documentId = getDocuments?.id;
    await dispatch(
      CustomerServicesApi.documentUpdateFile(
        formData,
        documentId,
        apiToken,
        enqueueSnackbar
      )
    );
    let isArchive = true
    await dispatch(
      CustomerServicesApi.getAllDocuments(
        selected,
        currentUser?.id,
        apiToken,
        isArchive
      )
    );
    setReload(false);
    setAlertunarchiveOpen(false);
    // setTimeout(() => {
    //   dispatch(
    //     CustomerServicesApi.getAllDocuments(
    //       selected,
    //       currentUser?.id,
    //       apiToken,
    //       isArchive
    //     )
    //   );
    // setReload(false);
    // setAlertArchiveOpen(false);
    // }, 2000);

  }
  const { pagination, toolbar, body, header } = Pagination();
  return (
    <div className="Documentlist-page-container">
      <Container fullWidth>
        {upload == "upload" ? (
          <Outlet />
        ) : (
          <Panel
            titleKey="document.titleKey.list"
            titleValues={action ? "button" : ""}
            // buttonTitle={"upload.button"}
            // pathLink={`/ms/administrations/archive/upload-document/${"upload"}`}
            icon={<CloudUpload style={{ marginRight: 5 }} />}
            role={currentUser?.role}
          >
            <MTable
              columns={bodydata}
              data={allDocuments?.length == undefined ? [] : allDocuments}
              isLoading={reload}
              actions={action ? [deleteDocument, downloadDocument] : []}
              localization={{ pagination, toolbar, body, header }}
              onPageChange={(page) => setPage(page)}
              onRowsPerPageChange={(pageSize: any) =>
                setRowsPerPage(parseInt(pageSize, 10))
              }
              // onRowClick={(event, rowData) => {
              //   downloadFile(rowData);
              // }}
              components={{
                Pagination: (props: any) => (
                  <Grid component="td" container>
                    <Grid item xs={6}>
                      <Typography className={classes.total}>
                        {formatMessage({ id: "component.mtable.total" })}
                        &nbsp;{allDocuments?.length}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <PaginationTable
                        props={props}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        count={allDocuments}
                      />
                    </Grid>
                  </Grid>
                ),
                Toolbar: (props) => (
                  <Grid container justifyContent="flex-end">
                    {currentUser?.role === "Admin" && (
                      <>
                        <Grid item className={classes.label}>
                          <label>
                            {formatMessage({
                              id: "customer.sort.by",
                              defaultMessage: "Sort by Customer",
                            })}{" "}
                            &nbsp;&nbsp;
                          </label>
                        </Grid>
                        <Grid item xs={3} style={{ paddingTop: 15 }}>
                          <SelectDropDown
                            handleChange={onhandleChange}
                            id="id"
                            OptionsValueId={
                              allCustomers == undefined ? [] : allCustomers
                            }
                            fieldName={"client"}
                            selected={selected}
                            ClassName={classes.select}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item>
                      <MTableToolbar {...props} />
                    </Grid>
                  </Grid>
                ),
              }}
            />
          </Panel>
        )}
        {alertDeleteOpen && (
          <DeleteAlert
            alertClose={() => setAlertDeleteOpen(false)}
            alertOpen={alertDeleteOpen}
            componentName={"document.document"}
            Submited={deletedDocument}
            deletedValue={getDocuments?.name}
          />
        )}
        {open && (
          <BoxDialog
            open={open}
            handleClose={closeBox}
            selectdata={permissionButton}
            url={`documents/`}
            document={"documentPermission"}
            columnName={"document"}
          />
        )}
      </Container>
    </div>
  );
};
